<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import AUApi from "@/api";

import { Globals } from "@/Globals";
import { globalsAic, globalsBegriffCache } from "@/local";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "@/editor/EditComponentStatic";
import {
  EditComboboxControlProps,
  EditComboBoxUiData,
} from "./EditComboboxFunctions";
const emitFn = defineEmits<CommonEditControlEmits>();

declare interface EditComboboxControlConfig extends EditorControlConfig {
  zeitbereich?: APIZeitbereich;
}
const props = defineProps<EditControlProps>();
const { config, ui } = getDefaultEditorControlConfig<
  EditComboboxControlConfig,
  EditComboboxControlProps,
  EditComboBoxUiData
>(props, emitFn);
const uiData = reactive(ui);
declare interface BtnItems {
  aic: number;
  bezeichnung: string;
  icon?: string;
  setShow?: boolean;
}

let btnItems: BtnItems[] = [];
let showLoading = ref<boolean>(false);
const textKennung: string = "BEZEICHNUNG";
let selected = ref<number | null>();

onMounted(async () => {
  mounted(uiData, props, config);
  uiData.selected = config.initValue;
  selected.value = uiData.selected?.aic ?? null;
  btnItems = config.column?.meta.combo ?? [];
  if (config.column?.meta.combo) {
    btnItems = config.column.meta.combo;
  } else if (config.column?.meta?.filter) {
    const filter = config.column.meta.filter;
    const query = globalsAic(Globals.Begriff, filter).kennung;
    const SbRefresh = globalsBegriffCache(Globals.Begriff, query);
    const cache = SbRefresh ? false : true; // SbRefresh = Berechtigung refresh - daher KEIN Cachen!
    if (query) {
      showLoading.value = true;
      const vecStamm: any[] = [];
      await AUApi.Current.getQuery(
        query,
        (data: any) => dataLoadedFromServer(data),
        0,
        config.zeitbereich,
        0,
        cache,
        false,
        "1",
        0,
        vecStamm
      );
    }
  }
});
async function dataLoadedFromServer(data: any) {
  try {
    const columns = data.data.columns;
    const combo = data.data.data;
    const bezCol = columns.find((c: any) => c.kennung === textKennung);
    const icon = columns.find((c: any) => c.kennung === "WEB_ICON");
    const setShow = columns.find((c: any) => c.kennung === "setShow");
    const columnBez = bezCol.name;
    const iconBez = icon.name;
    let showBez = "";
    if (setShow) {
      showBez = setShow.name;
    }
    if (combo.length > 0) {
      const mapped = combo.map((row: QueryDataRow): any => {
        return {
          aic: row.aic_Stamm,
          bezeichnung: row[columnBez],
          icon: row[iconBez],
          setShow: row[showBez],
        };
      });
      // gibt es nur 1nen Button - dann den initlisieren!
      if (mapped.length === 1) {
        checkedChanged(mapped[0]);
        // uiData.data = mapped[0];
        uiData.selected = mapped[0];
        selected.value = mapped[0].aic;
      }
      showLoading.value = false;
      btnItems = mapped;
    }
  } catch (err) {
    console.log(err);
  }
}
function checkedChanged(txt: BtnItems) {
  if (uiData.selected?.aic === txt.aic) {
    // uiData.data = txt;
  } else {
    // uiData.data = txt;
    uiData.selected = txt;
    selected.value = txt.aic;
  }
  valueChanged(config, uiData, uiData.selected);
}
</script>
<template>
  <div
    class="smallRow"
    align="center"
    justify="center"
    v-if="uiData.showMutable && !showLoading"
  >
    <v-tooltip
      :disabled="!uiData.showtooltip || !uiData.tooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-btn-toggle
          v-bind="props"
          v-model="selected"
          divided
          variant="outlined"
          color="primary"
          v-for="(btnItem, ux) in btnItems"
          :key="'ui' + ux"
          density="compact"
        >
          <v-btn
            size="small"
            :value="btnItem.aic"
            @click="checkedChanged(btnItem)"
            :prepend-icon="btnItem.icon"
            :variant="selected === btnItem.aic ? 'flat' : 'outlined'"
            density="compact"
          >
            <div v-if="btnItem.icon === undefined">
              {{ btnItem.bezeichnung }}
            </div>
          </v-btn>
        </v-btn-toggle>
        <!-- <ValueChangeTracker
          v-if="uiData.isChanged || props.disableValueChangeTracker"
        /> -->
      </template>
    </v-tooltip>
  </div>
</template>

<style scoped>
.v-label {
  font-size: 14px;
}
.smallRow {
  max-width: 95%;
  padding: 0 0 0 0;
}
</style>
